<template>
  <!-- externalQuery: searchQuery -->
  <b-modal
    :active.sync="active"
    :width="600"
    scroll="keep"
    class="feature-details"
  >
    <div class="card" style="height: 78vh; margin-left: 12px">
      <vue-good-table
        :columns="[
          { label: localization('app-index','Index'), field: 'key' },
          { label: localization('app-serial-num','Serial Num'), field: 'value' },
        ]"
        :rows="data"
        :search-options="{
          enabled: true,
          trigger: 'enter',
          skipDiacritics: true,
          placeholder: localization('app-search-this-table','Search this table'),
        }"
        :pagination-options="{
          enabled: true,
          mode: 'records',
          perPage: 10,
          position: 'top',
          perPageDropdown: [10, 25, 50],
          dropdownAllowAll: false,
          setCurrentPage: 1,
          nextLabel: localization('app-next', 'Next'),
          prevLabel: localization('app-prev', 'Prev'),
          rowsPerPageLabel: localization('app-rows-per-page', 'Rows per page'),
          ofLabel: 'of',
          pageLabel: 'page', // for 'pages' mode
          allLabel: 'All',
        }"
        :sort-options="{
          enabled: true,
          initialSortBy: { field: 'key', type: 'asc' },
        }"
      ></vue-good-table>
    </div>
  </b-modal>
</template>

<script>
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";

// add to component
export default {
  data() {
    return {
      active: false,
      data: [],
    };
  },
  created() {
    this.$root.$on("show_serial_number_table", (data) => {
      if (typeof data == "string") data = JSON.parse(data);
      this.data = _.entries(data).map((obj) => {
        return { key: obj[0], value: obj[1] };
      });
      this.active = true;
    });
  },
  components: {
    VueGoodTable,
  },
  methods: {
    myFunc(row, col, cellValue, searchTerm) {
      return cellValue === "my value";
    },
  },
};
</script>

<style>
.feature-details .card {
  border-radius: 10px;
  box-shadow: 0 15px 50px 0 rgba(0, 0, 0, 0.3);
  background-color: #f4f7fc;
}
</style>
